module.exports = __webpack_public_path__ + "img/logo_esq.3b558d0e.png";